import React, { useEffect, useState } from "react";
import menuIcon from "../assets/photos/30.png";
import workoutIcon from "../assets/photos/31.png";
import nutritionIcon from "../assets/photos/32.png";
import interactiveIcon from "../assets/photos/33.png";
import { Link, useNavigate } from "react-router-dom";

const ClientFooter = ({ userRole }) => {
  const [menuOpen, setMenuOpen] = useState(false);

  const nav = useNavigate();

  useEffect(() => {
  }, []);

  const logOut = () => {
    document.cookie = `tbt="";max-age=0;path='/'`;
    window.location.replace("/login");
  };

  const toggleMenu = () => {
    menuOpen ? setMenuOpen(false) : setMenuOpen(true);
  };

  if (userRole == "2") {
    return (
      <>
        <div className="clientFooter">
          <nav className="desktop">
            <a href={process.env.REACT_APP_BASE_URL} rel="noreferrer noopener">
              Main Site
            </a>
            <a href="/terms" rel="noreferrer noopener">
              Terms of Use
            </a>
          </nav>
          <nav className="mobile">
            <img src={menuIcon} onClick={toggleMenu} />
            <img
              src={workoutIcon}
              onClick={() => {
                nav("/client/workoutplan");
              }}
            />
            <img
              src={nutritionIcon}
              onClick={() => {
                nav("/client/nutritionplan");
              }}
            />
            <img
              src={interactiveIcon}
              onClick={() => {
                nav("/client/workouttracker");
              }}
            />
          </nav>
        </div>
        <div
          id="menu"
          className={
            menuOpen ? `mobileSlideOut menuOpen` : `mobileSlideOut menuClosed`
          }
          onClick={toggleMenu}
        >
          <label>Dashboard</label>
          <Link to="/client">Home</Link>
          <Link to="/client/account">Account</Link>
          <Link to="/client/workouttracker">Workout Tracker</Link>
          <Link to="/client/workoutplan">Workout Plan</Link>
          <Link to="/client/nutritionplan">Nutrition Plan</Link>
          <Link to="/client/tutorials">Workout Tutorials</Link>
          <Link to="/client/checkins">Checkin Forms</Link>
          <Link to="/client/checkinscheduling">Schedule a Checkin</Link>
          <label>Employee Tools</label>
          <Link to="/client/newcheckins">New Checkins</Link>
          <Link to="/client/oldcheckins">Old Checkins</Link>
          <Link to="/client/workoutplanning">Workout Planning</Link>
          <Link to="/client/nutritionplanning">Nutrition Planning</Link>
          <Link to="/client/workoutmanager">Workout Manager</Link>
          <Link to="/client/clientnotes">Client Notes</Link>
          <label>Admin Tools</label>
          <Link to="/client/ecom">E-Commerce</Link>            
          <Link to="/client/schedulingmanager">Scheduling Manager</Link>
          <Link to="/client/employeedatabase">Employee Database</Link>
          <Link to="/client/employeetasking">Employee Tasking</Link>
          <Link to="/client/clientdatabase">Client Database</Link>
          <label>Log Out</label>
          <button onClick={logOut}>Log Out</button>
        </div>
      </>
    );
  } else if (userRole == "1") {
    return (
      <>
        <div className="clientFooter">
          <nav className="desktop">
            <a href={process.env.REACT_APP_BASE_URL} rel="noreferrer noopener">
              Main Site
            </a>
            <a href="/terms" rel="noreferrer noopener">
              Terms of Use
            </a>
          </nav>
          <nav className="mobile">
            <img src={menuIcon} onClick={toggleMenu} />
            <img
              src={workoutIcon}
              onClick={() => {
                nav("/client/workoutplan");
              }}
            />
            <img
              src={nutritionIcon}
              onClick={() => {
                nav("/client/nutritionplan");
              }}
            />
            <img
              src={interactiveIcon}
              onClick={() => {
                nav("/client/workouttracker");
              }}
            />
          </nav>
        </div>
        <div
          className={menuOpen ? `mobileSlideOut menuOpen` : `mobileSlideOut`}
          onClick={toggleMenu}
        >
          <label>Dashboard</label>
          <Link to="/client">Home</Link>
          <Link to="/client/account">Account</Link>
          <Link to="/client/workouttracker">Workout Tracker</Link>
          <Link to="/client/workoutplan">Workout Plan</Link>
          <Link to="/client/nutritionplan">Nutrition Plan</Link>
          <Link to="/client/tutorials">Workout Tutorials</Link>
          <Link to="/client/checkins">Checkin Forms</Link>
          <Link to="/client/checkinscheduling">Schedule a Checkin</Link>
          <label>Employee Tools</label>
          <Link to="/client/newcheckins">New Checkins</Link>
          <Link to="/client/oldcheckins">Old Checkins</Link>
          <Link to="/client/workoutplanning">Workout Planning</Link>
          <Link to="/client/nutritionplanning">Nutrition Planning</Link>
          <Link to="/client/workoutmanager">Workout Manager</Link>
          <Link to="/client/clientnotes">Client Notes</Link>

          <label>Log Out</label>
          <button onClick={logOut}>Log Out</button>
        </div>
      </>
    );
  } else if (userRole == "0") {
    return (
      <>
        <div className="clientFooter">
          <nav className="desktop">
            <a href={process.env.REACT_APP_BASE_URL} rel="noreferrer noopener">
              Main Site
            </a>
            <a href={process.env.REACT_APP_BASE_URL} rel="noreferrer noopener">
              Terms of Use
            </a>
          </nav>
          <nav className="mobile">
            <img src={menuIcon} onClick={toggleMenu} />
            <img
              src={workoutIcon}
              onClick={() => {
                nav("/client/workoutplan");
              }}
            />
            <img
              src={nutritionIcon}
              onClick={() => {
                nav("/client/nutritionplan");
              }}
            />
            <img
              src={interactiveIcon}
              onClick={() => {
                nav("/client/workouttracker");
              }}
            />
          </nav>
        </div>
        <div
          className={
            menuOpen ? `mobileSlideOut menuOpen` : `mobileSlideOut menuClosed`
          }
          onClick={toggleMenu}
        >
          <label>Dashboard</label>
          <Link to="/client">Home</Link>
          <Link to="/client/account">Account</Link>
          <Link to="/client/workouttracker">Workout Tracker</Link>
          <Link to="/client/workoutplan">Workout Plan</Link>
          <Link to="/client/nutritionplan">Nutrition Plan</Link>
          <Link to="/client/tutorials">Workout Tutorials</Link>
          <Link to="/client/checkins">Checkin Forms</Link>
          <Link to="/client/checkinscheduling">Schedule a Checkin</Link>
          <label>Log Out</label>
          <Link to="/login">
            <button onClick={logOut}>Log Out</button>
          </Link>
        </div>
      </>
    );
  }
};

export default ClientFooter;
